import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { willPropose, willNotPropose, mayPropose, delegateRecipient } from 'proposals/api/procurementApiClient'

export const useWillPropose = (
  rfpId: string,
  recipientId: string,
  onSuccess: () => void
): UseMutationResult<void, unknown, void, unknown> => {
  return useMutation({
    mutationFn: () => willPropose(rfpId, recipientId),
    onSuccess
  })
}

export const useMayPropose = (
  rfpId: string,
  recipientId: string,
  onSuccess: () => void
): UseMutationResult<void, unknown, void, unknown> => {
  return useMutation({
    mutationFn: () => mayPropose(rfpId, recipientId),
    onSuccess
  })
}

export const useWillNotPropose = (
  rfpId: string,
  recipientId: string,
  onSuccess: () => void
): UseMutationResult<void, unknown, string, unknown> => {
  return useMutation({
    mutationFn: (reason: string) => willNotPropose(rfpId, recipientId, reason),
    onSuccess
  })
}

export const useDelegateRecipient = (
  rfpId: string,
  uniqueToken: string,
  onSuccess: () => void
): UseMutationResult<void, unknown, string, unknown> => {
  return useMutation({
    mutationFn: (email: string) => delegateRecipient(rfpId, uniqueToken, email),
    onSuccess
  })
}
